import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	movedColumn: {
		id: 'native-issue-table.issue-table.header.moved-column',
		defaultMessage: 'You’ve moved {column} from {previousPosition} to {position} of {total}.',
		description: 'Screen reader announcement when a table column is moved to a new position',
	},
});
